import { payments } from '@square/web-sdk';

import type { Card, GooglePay } from '@square/web-sdk';

/**
 * Squareサービスの支払いAPI
 */
export class PaymentSquareApi {
  /** カード */
  card: Card | undefined;

  /** Google pay */
  googlePay: GooglePay | undefined;

  /**
   * HTML要素に取り付ける
   * @param id 所属園のSquareのID
   * @param selectorOrElement HTML要素のID
   * @returns エラー
   */
  public async attach(
    id: {
      appId: string,
      locationId: string,
    },
    selectorOrElement: string,
  ) {
    await this.card?.detach();
    const payment = await payments(id.appId, id.locationId);
    if (payment) {
      this.card = await payment.card();
      await this.card.attach(selectorOrElement);
      return '';
    }
    return 'paymentUndefined';
  }

  /**
   * カード情報Tokenを取得する
   * @returns トークン
   */
  public async tokenize(): Promise<{
    /** エラー */
    error: string;
    /** トークン */
    token: string;
  }> {
    if (this.card) {
      const result = await this.card.tokenize();
      if (result.status === 'OK' && result.token) {
        return { error: '', token: result.token };
      }
      // eslint-disable-next-line no-console
      console.error(result);
      return { error: result.status.toString(), token: '' };
    }
    return {
      /** エラー */
      error: 'cardUndefined',
      /** トークン */
      token: '',
    };
  }
}
